<template>
  <v-app>
    <v-content>
      <v-container color="grey" fluid fill-height>
        <password
          title="Potwierdzenie konta"
          text="Podaj nowe hasło, aby potwierdzić założenie konta"
          @change="confirmAccount"
        ></password>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { authResource } from '@witkac/kartamiejska-resources';

import Password from '@/components/material/Password';
import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Widok potwierdzenia konta
// @group Account
export default {
  components: {
    Password
  },
  mixins: [notificationsMixin],
  methods: {
    // @vuese
    // Funkcja potwierdzająca konto
    confirmAccount(password) {
      authResource
        .confirm(this.$route.params.token, password)
        .then(() => {
          this.notifySuccess('Twoje konto zostało potwierdzone.');
          this.$router.push({ name: 'login' });
        })
        .catch(err => this.notifyError('Nie udało się potwierdzić twojego konta.'));
    }
  }
};
</script>

<style>
</style>
